import yup from '../../../config/yup';

export const learningStreamReaderValidationSchema = yup.object().shape({
  '@id': yup.string(),
  name: yup
    .string()
    .matches(/^[a-zA-Z_$][a-zA-Z0-9_$]*$/, {
      message:
        'Name must start with a letter or underscore and can only contain letters, numbers, and underscores',
    })
    .required('Name is required'),
  type: yup.string().default('learningStreamReader'),
  delayedRead: yup.boolean(),
  parameterizedBy: yup.string(),
  format: yup.string(),
  connectionKey: yup.string(),
  onError: yup.string(),
  properties: yup.object().shape({
    rootUrl: yup.string(),
    securityKey: yup.string(),
    accountCode: yup.string(),
    dataType: yup.string().required('Data Type is required'),
    acceptInvalidCerts: yup.boolean(),
    startDate: yup.string(),
    endDate: yup.string(),
    path: yup.string().required('Path is required'),
  }),
});
